module.exports = __webpack_public_path__ + "img/video-online.44935558.png";